import vuetify from "@/plugins/vuetify";

const state = {
  darkTheme: false,
  customTheme: false,

  dashboardHomePage: null,

  productGrid: true,
  productCountry: false,
  productCode: true,
  productSynonym: null,
  productQtyInBox: null,
  productFilters: true,
  showMenuDrawer: false,
  showHomeScreenPrompt: true,
};

const getters = {
  retrieveSettings: (state) => {
    return state;
  },

  retrieveDarkTheme: (state) => {
    return state.darkTheme;
  },

  retrieveDashboardHomePage: (state) => {
    return state.dashboardHomePage;
  },

  retrieveCustomTheme: (state) => {
    return state.customTheme;
  },

  retrieveProductGrid: (state) => {
    return state.productGrid;
  },

  retrieveProductCode: (state) => {
    return state.productCode;
  },

  retrieveProductSynonym: (state) => {
    return state.productSynonym;
  },

  retrieveQtyInBox: (state) => {
    return state.productQtyInBox;
  },

  retrieveProductCountry: (state) => {
    return state.productCountry;
  },

  retrieveProductFilters: (state) => {
    if (vuetify.framework.breakpoint.lgAndUp) {
      return state.productFilters;
    }

    return false;
  },

  retrieveShowMenuDrawer: (state) => {
    return state.showMenuDrawer;
  },

  retrieveHomeScreenPrompt: (state) => {
    return state.showHomeScreenPrompt;
  },
};

const actions = {
  setSettings({ commit }, payload) {
    const setSettingsResponse = commit("setSettings", payload);
    return setSettingsResponse;
  },

  clearSettings({ commit }) {
    const setSettingsResponse = commit("setSettings", null);
    return setSettingsResponse;
  },

  setDashboardHomePage({ commit }, payload) {
    const setSettingsResponse = commit("setDashboardHomePage", payload);
    return setSettingsResponse;
  },

  setDarkTheme({ commit }, payload) {
    const setSettingsResponse = commit("setDarkTheme", payload);
    return setSettingsResponse;
  },

  setCustomTheme({ commit }, payload) {
    const setSettingsResponse = commit("setCustomTheme", payload);
    return setSettingsResponse;
  },

  setVuetifyTheme({ commit }, payload) {
    const setSettingsResponse = commit("setVuetifyTheme", payload);
    return setSettingsResponse;
  },

  setProductGrid({ commit }, payload) {
    const setSettingsResponse = commit("setProductGrid", payload);
    return setSettingsResponse;
  },

  setProductCode({ commit }, payload) {
    const setSettingsResponse = commit("setProductCode", payload);
    return setSettingsResponse;
  },

  setProductSynonym({ commit }, payload) {
    const setSettingsResponse = commit("setProductSynonym", payload);
    return setSettingsResponse;
  },

  setProductQtyInBox({ commit }, payload) {
    const setSettingsResponse = commit("setProductQtyInBox", payload);
    return setSettingsResponse;
  },

  setProductFilters({ commit }, payload) {
    const setSettingsResponse = commit("setProductFilters", payload);
    return setSettingsResponse;
  },

  setProductCountry({ commit }, payload) {
    const setSettingsResponse = commit("setProductCountryCode", payload);
    return setSettingsResponse;
  },

  setShowMenuDrawer({ commit }, payload) {
    const setSettingsResponse = commit("setShowMenuDrawer", payload);
    return setSettingsResponse;
  },

  setHomeScreenPrompt({ commit }, payload) {
    const setSettingsResponse = commit("setHomeScreenPrompt", payload);
    return setSettingsResponse;
  },
};

const mutations = {
  setSettings: (state, settings) => (state = settings),

  setDashboardHomePage: (state, value) => (state.dashboardHomePage = value),

  setDarkTheme: (state, value) => (state.darkTheme = value),
  setCustomTheme: (state, value) => (state.customTheme = value),

  setVuetifyTheme: (state, theme) => {
    console.log("-- Theme to Update to");
    console.log(theme);

    const name = theme.name;
    const dark = theme.dark;
    const light = theme.light;

    // set themes
    Object.keys(dark).forEach((i) => {
      vuetify.framework.theme.themes.dark[i] = dark[i];
    });

    Object.keys(light).forEach((i) => {
      vuetify.framework.theme.themes.light[i] = light[i];
    });

    // also save theme name to disable selection
    vuetify.framework.theme.themes.name = name;

    return;
  },

  setProductGrid: (state, value) => (state.productGrid = value),
  setProductCode: (state, value) => (state.productCode = value),
  setProductSynonym: (state, value) => (state.productSynonym = value),
  setProductQtyInBox: (state, value) => (state.productQtyInBox = value),
  setProductFilters: (state, value) => (state.productFilters = value),
  setProductCountryCode: (state, value) => (state.productCountry = value),
  setShowMenuDrawer: (state, value) => (state.showMenuDrawer = value),
  setHomeScreenPrompt: (state, value) => (state.showHomeScreenPrompt = value),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
